module.exports = __webpack_public_path__ + "static/img/002.5bbfd3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/datav-headquarters/002.png
// module id = Swqy
// module chunks = 1